
import React, { useState } from "react";

const services = [
  {
    title: "Wedding Catering",
    image:
      "https://images.unsplash.com/photo-1555244162-803834f70033?q=80&w=1200&auto=format&fit=crop",
    desc: "Luxury catering services for grand wedding celebrations."
  },
  {
    title: "Corporate Events",
    image:
      "https://images.unsplash.com/photo-1528605248644-14dd04022da1?q=80&w=1200&auto=format&fit=crop",
    desc: "Professional food service for office meetings and corporate events."
  },
  {
    title: "Birthday Parties",
    image:
      "https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?q=80&w=1200&auto=format&fit=crop",
    desc: "Special birthday party catering with customized menu options."
  }
];

const products = [
  {
    name: "Paneer Butter Masala",
    image:
      "https://images.unsplash.com/photo-1631452180519-c014fe946bc7?q=80&w=1200&auto=format&fit=crop",
    price: "₹250"
  },
  {
    name: "Veg Biryani",
    image:
      "https://media.istockphoto.com/id/1337466448/photo/vegetarian-paneer-biryani-at-light-blue-background-paneer-biryani-is-traditional-veg-indian.webp?a=1&b=1&s=612x612&w=0&k=20&c=f753Fn7V-FhsZ5m6W0u3XpYYK9i2tbK2dqfTVlhDAH0=",
    price: "₹180"
  },
  {
    name: "South Indian Meal",
    image:
      "https://images.unsplash.com/photo-1606491956689-2ea866880c84?q=80&w=1200&auto=format&fit=crop",
    price: "₹220"
  },
  {
    name: "Chinese Combo",
    image:
      "https://images.unsplash.com/photo-1512058564366-18510be2db19?q=80&w=1200&auto=format&fit=crop",
    price: "₹300"
  },
  {
    name: "Dessert Special",
    image:
      "https://images.unsplash.com/photo-1563729784474-d77dbb933a9e?q=80&w=1200&auto=format&fit=crop",
    price: "₹150"
  },
  {
    name: "Snacks Package",
    image:
      "https://images.unsplash.com/photo-1504674900247-0877df9cc836?q=80&w=1200&auto=format&fit=crop",
    price: "₹120"
  }
];

const masalaProducts = [
  {
    name: "Sambhar Masala",
    image:
      "https://images.unsplash.com/photo-1596040033229-a9821ebd058d?q=80&w=1200&auto=format&fit=crop",
    price: "₹120"
  },
  {
    name: "Garam Masala",
    image:
      "https://images.unsplash.com/photo-1532336414038-cf19250c5757?q=80&w=1200&auto=format&fit=crop",
    price: "₹140"
  },
  {
    name: "Fish Masala",
    image:
      "https://images.unsplash.com/photo-1591465001609-ded6360ecaab?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    price: "₹160"
  },
  {
    name: "Biryani Masala",
    image:
      "https://images.unsplash.com/photo-1543376798-286a59d5da12?q=80&w=1176&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    price: "₹180"
  },
  {
    name: "Paneer Masala",
    image:
      "https://images.unsplash.com/photo-1594813593996-7f0d9868ce8e?q=80&w=674&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    price: "₹150"
  }
];

const reviews = [
  {
    name: "Rahul Sharma",
    review:
      "Excellent catering service with delicious food and professional staff."
  },
  {
    name: "Priya Verma",
    review:
      "Amazing taste and beautiful presentation. Guests loved every dish."
  },
  {
    name: "Amit Patel",
    review:
      "Affordable pricing and premium quality food for all events."
  }
];

export default function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  return (
    <div>
      <header className="header">
        <div className="logo">Chandana Catering Services</div>

        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          ☰
        </div>

        <nav className={menuOpen ? "nav active" : "nav"}>
          <a href="#home">Home</a>
          <a href="#about">About</a>
          <a href="#services">Services</a>
          <a href="#products">Products</a>
          <a href="#reviews">Reviews</a>
          <a href="#contact">Contact</a>
        </nav>
      </header>

      <section className="hero" id="home">
        <div className="overlay">
          <h1>Delicious Food For Every Occasion</h1>
          <p>
            Premium catering services for weddings, parties, family functions,
            corporate events and celebrations.
          </p>
          <button onClick={() => setShowPopup(true)}>Book Catering</button>
        </div>
      </section>

      <section className="about" id="about">
        <h2>About Us</h2>
        <p>
          Chandana Catering Services provides fresh, hygienic and delicious food
          with professional hospitality services. We have years of experience in
          wedding catering, birthday celebrations, family functions and business
          events.
        </p>

        <div className="about-boxes">
          <div className="info-box">
            <h3>10+ Years Experience</h3>
            <p>
              Successfully completed hundreds of catering projects across India.
            </p>
          </div>

          <div className="info-box">
            <h3>Fresh Ingredients</h3>
            <p>
              We use high quality fresh vegetables, spices and premium products.
            </p>
          </div>

          <div className="info-box">
            <h3>Customized Menu</h3>
            <p>
              Flexible menu options according to customer needs and budget.
            </p>
          </div>
        </div>
      </section>

      <section className="services" id="services">
        <h2>Our Services</h2>

        <div className="grid">
          {services.map((item, index) => (
            <div className="card" key={index}>
              <img src={item.image} alt={item.title} />
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
              <button onClick={() => setShowPopup(true)}>Order Now</button>
            </div>
          ))}
        </div>
      </section>

      <section className="products" id="products">
        <h2>Popular Food Products</h2>

        <div className="grid">
          {products.map((item, index) => (
            <div className="card" key={index}>
              <img src={item.image} alt={item.name} />
              <h3>{item.name}</h3>
              {/* <p>Starting From {item.price}</p> */}
              <button onClick={() => setShowPopup(true)}>Order Now</button>
            </div>
          ))}
        </div>
      </section>

      <section className="products" id="masala">
        <h2>ReadyMade Masala Products</h2>

        <div className="grid">
          {masalaProducts.map((item, index) => (
            <div className="card" key={index}>
              <img src={item.image} alt={item.name} />
              <h3>{item.name}</h3>
              <p>Starting From {item.price}</p>
              <button onClick={() => setShowPopup(true)}>Order Now</button>
            </div>
          ))}
        </div>
      </section>

      <section className="reviews" id="reviews">
        <h2>Client Reviews</h2>

        <div className="review-grid">
          {reviews.map((item, index) => (
            <div className="review-card" key={index}>
              <p>"{item.review}"</p>
              <h4>- {item.name}</h4>
            </div>
          ))}
        </div>
      </section>

      <section className="contact" id="contact">
        <h2>Contact Us</h2>

        <div className="contact-wrapper">
          <form className="contact-form">
            <input type="text" placeholder="Your Name" />
            <input type="email" placeholder="Your Email" />
            <input type="text" placeholder="Phone Number" />
            <textarea placeholder="Write your message"></textarea>
            <button type="submit">Submit</button>
          </form>

          <div className="contact-info">
            <h3>Business Details</h3>
            <p><strong>Name:</strong> Chandana</p>
            <p><strong>Email:</strong> admin@chandanacateringservices.online</p>
            <p><strong>Phone:</strong> +91-9102010780 </p>
            <p><strong>Address:</strong> Ajay Complex RAMANAGAR, NEAR Fruits Market , ,Ramanagara, Karnataka, 562166</p>

            <div className="timing">
              <h3>Opening Hours</h3>
              <p>Monday - Sunday</p>
              <p>9:00 AM - 10:00 PM</p>
            </div>
          </div>
        </div>
      </section>

      <footer className="footer">
        <p>© 2026 Chandana Catering Services. All Rights Reserved.</p>
      </footer>

      {showPopup && (
        <div className="popup">
          <div className="popup-content">
            <h3>For Order Please Call</h3>
            <p>+91-9102010780</p>
            <button onClick={() => setShowPopup(false)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
}
